import MyDropZone from './newFileInput'

export default MyDropZone
